import {type GatewayConfiguration} from '../../../models/GatewayConfiguration';
import {getLocaleText} from '../../../util/translation';
import {type AuthnetGateway} from '../authnet';
import cardBadgeURL from '../../../../img/badge/card.svg';
import cardImageURL from '../../../../img/marks/credit-card-regular.svg';
import {Feature} from '../../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../../@type/features';

function initAuthnetCardMethod(): AuthnetGateway {
	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.AUTHNET_CARD_GATEWAY, 'title') ?? getLocaleText('Card'),
		gatewayId: 'peachpay_authnet_card',
		description: `${getLocaleText('After clicking <b>Pay</b>, a window will appear where you can enter your card information.')}`,
		assets: {
			title: {src: cardImageURL},
			badge: {src: cardBadgeURL},
		},
	};

	return {
		config,
	};
}

export {initAuthnetCardMethod};
